// extracted by mini-css-extract-plugin
export default {"shortSeparator":"l73lid"};